import { bookingLink, bookingOf, type Bookable } from '../lib/booking'
import { useLaneFlag } from '../lib/laneFlag'
import { r3f } from '../copyR3Filters'
import { ArrowUpRight, Calendar } from '../ui/icons'

/**
 * R-105 (Round 3, Lane 3): one plain line for places that need an appointment or a reservation, with the booking link.
 * Shown on the listing detail and on an itinerary stop; nothing for everything else (lib/booking.ts says which).
 */
export function BookingNote({ item, className = '' }: { item: Bookable | null | undefined; className?: string }) {
  const on = useLaneFlag('booking_note')
  const kind = on ? bookingOf(item) : null
  if (!kind || !item) return null
  const href = bookingLink(item)
  return (
    <p data-review-id="booking-note" data-booking={kind} className={`t-meta flex flex-wrap items-center gap-x-2 text-ink ${className}`}>
      <Calendar size={16} className="shrink-0 text-ink-2" aria-hidden="true" />
      <span>{r3f(kind === 'appointment' ? 'r3f.book.appointment' : 'r3f.book.reservation')}</span>
      {href && (
        <a href={href} target="_blank" rel="noopener noreferrer" data-review-id="booking-link" className="press inline-flex min-h-11 items-center gap-0.5 font-semibold text-accent-ink underline underline-offset-4">
          {r3f('r3f.book.link')}<ArrowUpRight size={15} />
        </a>
      )}
    </p>
  )
}
